import { RowSelectionState } from "@tanstack/react-table";
import { FetchProfilesResponse } from "PFCore/services/profile";
import { OrderOption, TableColumn } from "PFTypes";
import { createContext, Dispatch, RefObject, SetStateAction } from "react";

import { ViewMode } from "../profiles_page.types";

type ProfilesPageContextProvider = {
  profiles: FetchProfilesResponse["entries"];
  meta: FetchProfilesResponse["meta"];
  isFetching: boolean;
  error: any;
  order: OrderOption | null;
  setOrder: (newOrder: OrderOption) => void;
  viewMode: ViewMode;
  selectedIds: RowSelectionState;
  setSelectedIds: Dispatch<SetStateAction<RowSelectionState>>;
  selectedColumns: TableColumn[];
  setSelectedColumns: (columns: TableColumn[]) => void;
  setViewMode: (newViewMode: ViewMode) => void;
  setCurrentPage: (page: number) => void;
  scrollableContainerRef: RefObject<HTMLDivElement | null>;
};

export const ProfilesPageContext = createContext({} as ProfilesPageContextProvider);
